import { MsalAuthProvider, LoginType } from "react-aad-msal";
import { LogLevel, Logger, AuthResponse } from "msal";

const logger = new Logger(
  (logLevel, message, containsPii) => {
    console.log("[MSAL]", message);
  },
  {
    level: LogLevel.Verbose,
    piiLoggingEnabled: false
  }
);

// The auth provider should be a singleton. Best practice is to only have it ever instantiated once.
// Avoid creating an instance inside the component it will be recreated on each render.
// If two providers are created on the same page it will cause authentication errors.
export const authProvider = new MsalAuthProvider(
  {
    auth: {
      authority: "https://ultimatesprodev.b2clogin.com/ultimatesprodev.onmicrosoft.com/B2C_1A_signup_signin",
      clientId: "bd0f0ab0-7788-42be-99d7-e2afd5b69014",
      postLogoutRedirectUri: window.location.origin,
      redirectUri: window.location.origin,
      validateAuthority: false,

      // After being redirected to the "redirectUri" page, should user
      // be redirected back to the Url where their login originated from?
      navigateToLoginRequestUrl: false
    },
    // Enable logging of MSAL events for easier troubleshooting.
    // This should be disabled in production builds.
    system: {
      logger: logger as any
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: false
    }
  },
  {
    scopes: ["https://graph.microsoft.com/offline_access"]
  },
  {
    loginType: LoginType.Redirect,
    // When a token is refreshed it will be done by loading a page in an iframe.
    // Rather than reloading the same page, we can point to an empty html file which will prevent
    // site resources from being loaded twice.
    tokenRefreshUri: window.location.origin + "/auth.html"
  }
);

export const getTokenPopup = (request:any) :Promise<void |AuthResponse> => {
  return authProvider.acquireTokenSilent(request)
    .catch(error => {
      console.log(error);
      // console.log("silent token acquisition fails. acquiring token using popup");
          
      // fallback to interaction when silent call fails
      return authProvider.acquireTokenPopup(request)
        .then(tokenResponse => {
          return tokenResponse;
        }).catch(error => {
          console.log(error);
        });
  });
};